import {getTodoCollectionPath, type TodoDb} from '@cp/model';
import {doc, DocumentReference} from 'firebase/firestore';
import {firebaseFirestore} from '../../config/firebase';

export default function getTodoDocRef(uid: string, todoId: string): DocumentReference<TodoDb> {
  return doc(firebaseFirestore, getTodoCollectionPath(uid), todoId) as DocumentReference<TodoDb>;
}
